const NotFound = () => {
  return (
    <section className="page">
      <h1>404 - Page Not Found</h1>
    </section>
  );
};

export default NotFound;